import type { Idioma } from "./IdiomaProvider";

export const TEXTOS_MONITOR_TEF_FISCAL_COMPLEMENTO: Record<Idioma, Record<string, string>> = {
  pt: {},
  en: {
    "Não foi possível carregar as transações TEF.": "Could not load EFT transactions.",
    "Não foi possível consultar o TEF.": "Could not check the EFT transaction.",
    "Não foi possível desfazer a transação.": "Could not undo the transaction.",
    "Comprovante ainda não disponível.": "Receipt is not available yet.",
    "Não foi possível carregar os documentos fiscais.": "Could not load fiscal documents.",
    "Não foi possível consultar o documento.": "Could not check the document.",
    "Não foi possível concluir a operação fiscal.": "Could not complete the fiscal operation.",
    "Cancelamento fiscal solicitado.": "Fiscal cancellation requested.",
    "Carta de correção autorizada.": "Correction letter authorized.",
    "Numeração inutilizada.": "Number range voided.",
    "Número / Série": "Number / Series",
    "Referência": "Reference",
    "Retorno": "Response",
    "Informe somente dados permitidos pela legislação fiscal.": "Enter only data allowed by fiscal law.",
    "Informe uma justificativa com pelo menos 15 caracteres.": "Enter a justification with at least 15 characters.",
    "Evento fiscal": "Fiscal event",
    "Correção": "Correction",
    "Registre a faixa não utilizada diretamente na SEFAZ pela Focus NFe.": "Register the unused range with SEFAZ through Focus NFe.",
    "Faixa fiscal": "Fiscal range",
    "Série": "Series",
    "Número inicial": "Start number",
    "Número final": "End number",
    "Configure terminais, impressão, ambiente seguro de cancelamento e regras fiscais por empresa.": "Configure terminals, printing, secure cancellation and fiscal rules per company.",
    "Segredos do e-SiTef são criptografados no servidor e nunca são devolvidos ao navegador. Deixe os campos secretos vazios para manter os valores atuais.": "e-SiTef secrets are encrypted on the server and never returned to the browser. Leave secret fields blank to keep current values.",
    "Credenciais e-SiTef": "e-SiTef credentials",
    "Pin pad": "PIN pad",
    "Cadastre cada caixa físico que utiliza o e-SiTef.": "Register each physical checkout terminal that uses e-SiTef.",
    "Cadastre regras por documento, UF e regime tributário.": "Register rules by document, state and tax regime.",
    "Terminal PDV salvo.": "POS terminal saved.",
    "Regra fiscal salva.": "Fiscal rule saved.",
    "Não foi possível carregar as configurações do PDV.": "Could not load POS settings.",
    "Não foi possível salvar o terminal.": "Could not save the terminal.",
    "Não foi possível salvar a regra fiscal.": "Could not save the fiscal rule.",
    "Editar terminal PDV": "Edit POS terminal",
    "Novo terminal PDV": "New POS terminal",
    "As credenciais são enviadas somente ao servidor e armazenadas com criptografia.": "Credentials are sent only to the server and stored encrypted.",
    "Company code": "Company code",
    "Terminal ID": "Terminal ID",
    "Editar regra fiscal": "Edit fiscal rule",
    "A regra de menor prioridade aplicável será usada na emissão.": "The applicable rule with the lowest priority value will be used for issuance.",
    "Regra fiscal": "Fiscal rule",
    "Informe o valor contado em cada forma de pagamento antes do fechamento.": "Enter the counted amount for each payment method before closing.",
    "Obrigatória quando houver divergência": "Required when there is a discrepancy",
    "Conferência enviada para aprovação.": "Reconciliation sent for approval.",
    "Conferência concluída.": "Reconciliation completed.",
    "Divergência aprovada.": "Discrepancy approved.",
    "Não foi possível carregar a conferência.": "Could not load the reconciliation.",
    "Não foi possível salvar a conferência.": "Could not save the reconciliation.",
    "Não foi possível aprovar a conferência.": "Could not approve the reconciliation.",
    "Monitor de pagamentos eletrônicos e pendências do provedor.": "Electronic payment and provider pending-item monitor.",
    "Monitor de documentos, contingência e eventos fiscais.": "Fiscal document, contingency and event monitor.",
    "Terminais, impressão e regras fiscais do ponto de venda.": "Point-of-sale terminals, printing and fiscal rules.",
  },
  es: {
    "Cancelamentos de pagamentos já confirmados são feitos no portal seguro da Software Express. Depois, use Consultar para reconciliar o ERP.": "Los pagos ya confirmados se cancelan en el portal seguro de Software Express. Después, use Consultar para conciliar el ERP.",
    "Buscar por venda, NSU ou autorização...": "Buscar por venta, NSU o autorización...",
    "Desfazer esta transação TEF pendente?": "¿Deshacer esta transacción TEF pendiente?",
    "Situação TEF atualizada.": "Estado TEF actualizado.",
    "Transação pendente desfeita.": "Transacción pendiente deshecha.",
    "Não foi possível carregar as transações TEF.": "No se pudieron cargar las transacciones TEF.",
    "Não foi possível consultar o TEF.": "No se pudo consultar la transacción TEF.",
    "Não foi possível desfazer a transação.": "No se pudo deshacer la transacción.",
    "Comprovante ainda não disponível.": "El comprobante aún no está disponible.",
    "As transações do caixa aparecerão aqui.": "Las transacciones de caja aparecerán aquí.",
    "Vias retornadas pelo ambiente seguro do provedor.": "Copias devueltas por el entorno seguro del proveedor.",
    "Comprovante não disponível.": "Comprobante no disponible.",
    "Acompanhe NF-e, NFC-e e NFS-e, consulte retornos e execute eventos fiscais.": "Acompañe NF-e, NFC-e y NFS-e, consulte respuestas y ejecute eventos fiscales.",
    "Buscar por venda, número ou referência...": "Buscar por venta, número o referencia...",
    "Situação fiscal atualizada.": "Estado fiscal actualizado.",
    "Não foi possível carregar os documentos fiscais.": "No se pudieron cargar los documentos fiscales.",
    "Não foi possível consultar o documento.": "No se pudo consultar el documento.",
    "Não foi possível concluir a operação fiscal.": "No se pudo completar la operación fiscal.",
    "Cancelamento fiscal solicitado.": "Cancelación fiscal solicitada.",
    "Carta de correção autorizada.": "Carta de corrección autorizada.",
    "Numeração inutilizada.": "Numeración inutilizada.",
    "Número / Série": "Número / Serie",
    "Referência": "Referencia",
    "Retorno": "Respuesta",
    "Nenhum documento fiscal encontrado": "No se encontraron documentos fiscales",
    "Os documentos emitidos pelo ERP aparecerão aqui.": "Los documentos emitidos por el ERP aparecerán aquí.",
    "Cancelar documento fiscal": "Cancelar documento fiscal",
    "Informe somente dados permitidos pela legislação fiscal.": "Ingrese solo datos permitidos por la legislación fiscal.",
    "Informe uma justificativa com pelo menos 15 caracteres.": "Ingrese una justificación de al menos 15 caracteres.",
    "Evento fiscal": "Evento fiscal",
    "Correção": "Corrección",
    "Registre a faixa não utilizada diretamente na SEFAZ pela Focus NFe.": "Registre el rango no utilizado ante SEFAZ mediante Focus NFe.",
    "Faixa fiscal": "Rango fiscal",
    "Série": "Serie",
    "Número inicial": "Número inicial",
    "Número final": "Número final",
    "Configure terminais, impressão, ambiente seguro de cancelamento e regras fiscais por empresa.": "Configure terminales, impresión, cancelación segura y reglas fiscales por empresa.",
    "Segredos do e-SiTef são criptografados no servidor e nunca são devolvidos ao navegador. Deixe os campos secretos vazios para manter os valores atuais.": "Los secretos de e-SiTef se cifran en el servidor y nunca vuelven al navegador. Deje los campos secretos vacíos para conservar los valores actuales.",
    "Credenciais e-SiTef": "Credenciales de e-SiTef",
    "Pin pad": "PIN pad",
    "Nenhum terminal configurado": "No hay terminales configurados",
    "Cadastre cada caixa físico que utiliza o e-SiTef.": "Registre cada caja física que utilice e-SiTef.",
    "Nenhuma regra fiscal configurada": "No hay reglas fiscales configuradas",
    "Cadastre regras por documento, UF e regime tributário.": "Registre reglas por documento, estado y régimen tributario.",
    "Terminal PDV salvo.": "Terminal PDV guardado.",
    "Regra fiscal salva.": "Regla fiscal guardada.",
    "Não foi possível carregar as configurações do PDV.": "No se pudo cargar la configuración del PDV.",
    "Não foi possível salvar o terminal.": "No se pudo guardar el terminal.",
    "Não foi possível salvar a regra fiscal.": "No se pudo guardar la regla fiscal.",
    "Editar terminal PDV": "Editar terminal PDV",
    "Novo terminal PDV": "Nuevo terminal PDV",
    "As credenciais são enviadas somente ao servidor e armazenadas com criptografia.": "Las credenciales se envían solo al servidor y se almacenan cifradas.",
    "Company code": "Código de empresa",
    "Terminal ID": "ID del terminal",
    "Editar regra fiscal": "Editar regla fiscal",
    "A regra de menor prioridade aplicável será usada na emissão.": "Para la emisión se usará la regla aplicable con menor valor de prioridad.",
    "Regra fiscal": "Regla fiscal",
    "Informe o valor contado em cada forma de pagamento antes do fechamento.": "Informe el valor contado de cada forma de pago antes del cierre.",
    "Obrigatória quando houver divergência": "Obligatoria cuando exista diferencia",
    "Conferência enviada para aprovação.": "Arqueo enviado para aprobación.",
    "Conferência concluída.": "Arqueo completado.",
    "Divergência aprovada.": "Diferencia aprobada.",
    "Não foi possível carregar a conferência.": "No se pudo cargar el arqueo.",
    "Não foi possível salvar a conferência.": "No se pudo guardar el arqueo.",
    "Não foi possível aprovar a conferência.": "No se pudo aprobar el arqueo.",
    "Monitor de pagamentos eletrônicos e pendências do provedor.": "Monitor de pagos electrónicos y pendientes del proveedor.",
    "Monitor de documentos, contingência e eventos fiscais.": "Monitor de documentos, contingencias y eventos fiscales.",
    "Terminais, impressão e regras fiscais do ponto de venda.": "Terminales, impresión y reglas fiscales del punto de venta.",
  },
  "zh-CN": {
    "Acompanhe pagamentos, comprovantes e pendências do e-SiTef sem expor dados de cartão.": "跟踪 e-SiTef 支付、凭证和待处理事项，且不暴露银行卡数据。",
    "Cancelamentos de pagamentos já confirmados são feitos no portal seguro da Software Express. Depois, use Consultar para reconciliar o ERP.": "已确认支付需在 Software Express 安全门户中取消，随后使用“查询”与 ERP 对账。",
    "Buscar por venda, NSU ou autorização...": "按销售、NSU 或授权码搜索…",
    "Desfazer esta transação TEF pendente?": "是否撤销此待处理电子支付交易？",
    "Situação TEF atualizada.": "电子支付状态已更新。",
    "Transação pendente desfeita.": "待处理交易已撤销。",
    "Não foi possível carregar as transações TEF.": "无法加载电子支付交易。",
    "Não foi possível consultar o TEF.": "无法查询电子支付交易。",
    "Não foi possível desfazer a transação.": "无法撤销交易。",
    "Comprovante ainda não disponível.": "凭证尚不可用。",
    "As transações do caixa aparecerão aqui.": "收银交易将显示在此处。",
    "Vias retornadas pelo ambiente seguro do provedor.": "由服务商安全环境返回的凭证副本。",
    "Comprovante não disponível.": "凭证不可用。",
    "Acompanhe NF-e, NFC-e e NFS-e, consulte retornos e execute eventos fiscais.": "跟踪 NF-e、NFC-e 和 NFS-e，查询结果并执行税务事件。",
    "Buscar por venda, número ou referência...": "按销售、号码或参考号搜索…",
    "Situação fiscal atualizada.": "税务状态已更新。",
    "Não foi possível carregar os documentos fiscais.": "无法加载税务单据。",
    "Não foi possível consultar o documento.": "无法查询单据。",
    "Não foi possível concluir a operação fiscal.": "无法完成税务操作。",
    "Cancelamento fiscal solicitado.": "已申请取消税务单据。",
    "Carta de correção autorizada.": "更正函已授权。",
    "Numeração inutilizada.": "号码段已作废。",
    "Número / Série": "号码 / 系列",
    "Referência": "参考号",
    "Retorno": "返回结果",
    "Nenhum documento fiscal encontrado": "未找到税务单据",
    "Os documentos emitidos pelo ERP aparecerão aqui.": "ERP 开具的单据将显示在此处。",
    "Cancelar documento fiscal": "取消税务单据",
    "Informe somente dados permitidos pela legislação fiscal.": "请仅输入税法允许的数据。",
    "Informe uma justificativa com pelo menos 15 caracteres.": "请输入至少 15 个字符的说明。",
    "Evento fiscal": "税务事件",
    "Correção": "更正内容",
    "Registre a faixa não utilizada diretamente na SEFAZ pela Focus NFe.": "通过 Focus NFe 向 SEFAZ 登记未使用的号码段。",
    "Faixa fiscal": "税务号码段",
    "Série": "系列",
    "Número inicial": "起始号码",
    "Número final": "结束号码",
    "Configure terminais, impressão, ambiente seguro de cancelamento e regras fiscais por empresa.": "按公司配置终端、打印、安全取消环境和税务规则。",
    "Segredos do e-SiTef são criptografados no servidor e nunca são devolvidos ao navegador. Deixe os campos secretos vazios para manter os valores atuais.": "e-SiTef 密钥在服务器端加密，绝不返回浏览器。留空密钥字段可保留当前值。",
    "Credenciais e-SiTef": "e-SiTef 凭据",
    "Pin pad": "密码键盘",
    "Nenhum terminal configurado": "尚未配置终端",
    "Cadastre cada caixa físico que utiliza o e-SiTef.": "请登记每个使用 e-SiTef 的实体收银终端。",
    "Nenhuma regra fiscal configurada": "尚未配置税务规则",
    "Cadastre regras por documento, UF e regime tributário.": "请按单据、州和税制登记规则。",
    "Terminal PDV salvo.": "POS 终端已保存。",
    "Regra fiscal salva.": "税务规则已保存。",
    "Não foi possível carregar as configurações do PDV.": "无法加载 POS 设置。",
    "Não foi possível salvar o terminal.": "无法保存终端。",
    "Não foi possível salvar a regra fiscal.": "无法保存税务规则。",
    "Editar terminal PDV": "编辑 POS 终端",
    "Novo terminal PDV": "新建 POS 终端",
    "As credenciais são enviadas somente ao servidor e armazenadas com criptografia.": "凭据仅发送到服务器并加密存储。",
    "Company code": "公司代码",
    "Terminal ID": "终端 ID",
    "Editar regra fiscal": "编辑税务规则",
    "A regra de menor prioridade aplicável será usada na emissão.": "开票时将使用优先级数值最低的适用规则。",
    "Regra fiscal": "税务规则",
    "Informe o valor contado em cada forma de pagamento antes do fechamento.": "关账前请输入各支付方式的盘点金额。",
    "Obrigatória quando houver divergência": "存在差异时必填",
    "Conferência enviada para aprovação.": "核对结果已提交审批。",
    "Conferência concluída.": "核对已完成。",
    "Divergência aprovada.": "差异已批准。",
    "Não foi possível carregar a conferência.": "无法加载收银核对。",
    "Não foi possível salvar a conferência.": "无法保存收银核对。",
    "Não foi possível aprovar a conferência.": "无法批准收银核对。",
    "Monitor de pagamentos eletrônicos e pendências do provedor.": "电子支付及服务商待处理事项监控。",
    "Monitor de documentos, contingência e eventos fiscais.": "税务单据、应急模式和事件监控。",
    "Terminais, impressão e regras fiscais do ponto de venda.": "销售点终端、打印和税务规则。",
  },
};
